import { h } from 'preact';
import styles from './GridBanner.module.scss';
export function GridBanner({ config, class: extraClass }) {
    const { image, heading, buttonText, buttonLink, isWide } = config;
    const classNames = [styles.banner, isWide && styles.bannerWide, extraClass]
        .filter(Boolean)
        .join(' ');
    return (h("div", { class: classNames },
        h("img", { class: styles.bannerImage, src: image, alt: "" }),
        heading && h("p", { class: styles.bannerHeading }, heading),
        buttonLink && (h("a", { href: buttonLink, class: styles.bannerButton }, buttonText))));
}
